import { render, staticRenderFns } from "./3.vue?vue&type=template&id=639f284a&scoped=true"
import script from "./3.vue?vue&type=script&lang=js"
export * from "./3.vue?vue&type=script&lang=js"
import style0 from "./3.vue?vue&type=style&index=0&id=639f284a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f284a",
  null
  
)

export default component.exports